import { createSlice } from '@reduxjs/toolkit';
import actions from './actions';
import { NAME_REDUCER } from './constants';
import { IState } from '../interfaces/reducer';

const initialState: IState = {
  dataDemo: [],
  screensList: null,
  screensParam: {
    page: 1,
    size: 10,
  },
  summaryStats: null,
};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(actions.getDemoData.success, (state, { payload }) => {
        state.dataDemo = payload;
      })
      .addCase(actions.getListScreens.success, (state, { payload }) => {
        state.screensList = payload;
      })
      .addCase(actions.setScreensParam, (state, { payload }) => {
        state.screensParam = payload;
      })
      .addCase(actions.getSummaryStats.success, (state, { payload }) => {
        state.summaryStats = payload;
      })
      .addCase(actions.updateStatusScreen.success, (state, { payload }) => {
        const current = state.screensList;
        if (current) {
          const newContent = current.content.map(item => 
            item.id === payload.id ? { ...item, status: payload.status } : item
          );
          state.screensList = {
            ...current,
            content: newContent,
          };
        }
      });
  },
});

export const dashboardUIActions = Slice.actions;
const dashboardServiceReducer = Slice.reducer;
export default dashboardServiceReducer;
